import { LIST_CITY, LIST_DISTRICT, LIST_WARD } from "@/stores/actions";

import { SET_CITY, SET_DISTRICT, SET_WARD } from "@/stores/mutations";

import { AddressServiceAPI } from "@/api/address";
import { transformVM } from "@/transforms";
import { sortAlphabetically } from "@/ultils";

export const actions = {
  async [LIST_CITY]({ commit }, params) {
    try {
      let result = await AddressServiceAPI.getProvinces(params);
      if (result && result.data && typeof result.data.data !== "undefined") {
        const sortedArray = sortAlphabetically(result.data.data);
        commit(SET_CITY, transformVM.addressVM.transformCities(sortedArray));
      }
      return result;
    } catch (e) {
      return e;
    }
  },

  async [LIST_DISTRICT]({ commit }, params) {
    try {
      let result = await AddressServiceAPI.getDistricts(params);
      if (result && result.data && typeof result.data.data !== "undefined") {
        const sortedArray = sortAlphabetically(result.data.data);
        commit(
          SET_DISTRICT,
          transformVM.addressVM.transformDistricts(sortedArray)
        );
      }
      return result;
    } catch (e) {
      return e;
    }
  },

  async [LIST_WARD]({ commit }, params) {
    try {
      let result = await AddressServiceAPI.getWards(params);
      if (result && result.data && typeof result.data.data !== "undefined") {
        const sortedArray = sortAlphabetically(result.data.data);
        commit(SET_WARD, transformVM.addressVM.transformWards(sortedArray));
      }
      return result;
    } catch (e) {
      return e;
    }
  },
};
